<div class="landing-v2">
  <div class="home__page">
    <div class="main-container">
      <main id="middle" class="middle__sec">
        <section class="home__hero">
          <div class="container">
            <div class="row">
              <div class="col-lg-6">
                <div class="hero__caption">
                  <span i18n class="tagline">LA RÉUSSITE EN 1 CLIC</span>
                  <h1 i18n class="title">Le site de préparation aux EDN</h1>
                  <p i18n class="desc">
                    La référence de préparation aux EDN depuis 2013. Mets toutes les chances de ton
                    coté dès maintenant.
                  </p>
                </div>

                <div class="hero__ns">
                  <input
                    type="email"
                    i18n-placeholder
                    placeholder="Email"
                    [(ngModel)]="registerEmail"
                    name="registerEmail"
                  />
                  <button class="send__btn" (click)="registerWithEmail()">
                    <img
                      src="assets/assets-site/images/landing-v2/send-arw.svg"
                      alt=""
                      class="svg"
                    />
                  </button>
                </div>

                <div class="hero__social">
                  <label i18n class="lbl">Accès direct :</label>
                  <div class="hero__social__icons">
                    <div (click)="SSOFacebookLogin()" class="hero__social__btn">
                      <img
                        src="assets/assets-site/images/landing-v2/facebook.svg"
                        alt=""
                        class="svg"
                      />
                    </div>
                    <div (click)="SSOAppleLogin()" class="hero__social__btn">
                      <img
                        src="assets/assets-site/images/landing-v2/apple.svg"
                        alt=""
                        class="svg"
                      />
                    </div>
                    <div (click)="SSOGoogleLogin()" class="hero__social__btn">
                      <img
                        src="assets/assets-site/images/landing-v2/google.svg"
                        alt=""
                        class="svg"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-5">
                <div class="hero__devices">
                  <div class="hero__devices__one">
                    <img
                      src="assets/assets-site/images/landing-v2/hero-device-one.png"
                      alt=""
                      class=""
                    />
                  </div>
                  <div class="hero__devices__two">
                    <img
                      src="assets/assets-site/images/landing-v2/hero-device-two.png"
                      alt=""
                      class=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div appObserveVisibility (visible)="getApplicationStats()"></div>

        <section class="numbers__section cmn__section" id="sectionSavoir">
          <div class="container">
            <div class="numbers__blk">
              <div class="numbers__blk__lt">
                <h2 i18n class="hdng">
                  La plus
                  <strong>grande communauté d’étudiants</strong> préparant le concours
                </h2>
              </div>
              <div class="numbers__blk__rt">
                <div class="numbers__col">
                  <i class="icon">
                    <img
                      src="assets/assets-site/images/landing-v2/check-white.svg"
                      alt=""
                      class="svg"
                    />
                  </i>
                  <ng-container
                    *ngIf="componentStore.applicationStats$ | async as applicationStats"
                  >
                    <span class="ttl">{{
                      applicationStats.totalSessions | number : '1.0-0' : 'fr'
                    }}</span>
                    <small i18n class="lbl">Participations</small>
                  </ng-container>
                </div>
                <div class="numbers__col">
                  <i class="icon">
                    <img
                      src="assets/assets-site/images/landing-v2/group-white.svg"
                      alt=""
                      class="svg"
                    />
                  </i>
                  <ng-container
                    *ngIf="componentStore.applicationStats$ | async as applicationStats"
                  >
                    <span class="ttl">{{
                      applicationStats.totalUsers | number : '1.0-0' : 'fr'
                    }}</span>
                    <small i18n class="lbl">Etudiants</small>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="overview__section cmn__section">
          <div class="container">
            <div class="overview__content">
              <div class="overview__lt">
                <div class="overview__card">
                  <figure class="thumb">
                    <img
                      src="assets/assets-site/images/landing-v2/overview-thumb-one.webp"
                      alt=""
                    />
                  </figure>
                  <figcaption class="caption">
                    <h6 i18n class="ttl">HugoHsn</h6>
                    <p i18n class="desc">
                      J'utilise EDN depuis le début de ma D2, et depuis je n'ai pas pu m'en passer
                      pendant une seule journée de révision <strong>111ème EDN23</strong>
                    </p>
                  </figcaption>
                </div>
              </div>

              <div class="overview__rt">
                <div class="block__ttl">
                  <h2 i18n class="block__ttl__hdng">
                    La plus grande quantité de <br />contenu pour les EDN et les ECOS
                  </h2>
                  <p i18n class="block__ttl__desc">
                    Avec des outils et des ressources pour vous accompagner<br />
                    efficacement dans la maîtrise des connaissances et la réussite .
                  </p>
                </div>

                <div class="overview__grid">
                  <div class="overview__grid__lt">
                    <div class="overview__cols">
                      <div class="overview__count">
                        <div class="overview__count__top">
                          <i class="icon">
                            <img
                              src="assets/assets-site/images/landing-v2/ques-icon.svg"
                              alt=""
                              class="svg"
                            />
                          </i>
                          <div
                            *ngIf="componentStore.applicationStats$ | async as applicationStats"
                            class="ttl"
                          >
                            {{
                              applicationStats.totalPublishedOnTrainingQuestions +
                                applicationStats.totalPublishedFolderQuestions +
                                applicationStats.totalUnpublishedOnTrainingPublishedOnExamExamContentQuestions
                                | number : '1.0-0' : 'fr'
                            }}
                            <small i18n>questions</small>
                          </div>
                        </div>
                        <p i18n class="desc">
                          Une somme inégalée de questions pour être préparé à toutes les
                          éventualités le jour J.
                        </p>
                      </div>

                      <div class="overview__count">
                        <div class="overview__count__top">
                          <i class="icon">
                            <img
                              src="assets/assets-site/images/landing-v2/exam-icon.svg"
                              alt=""
                              class="svg"
                            />
                          </i>
                          <div
                            *ngIf="componentStore.applicationStats$ | async as applicationStats"
                            class="ttl"
                          >
                            {{ applicationStats.totalPublishedExams | number : '1.0-0' : 'fr' }}
                            <small i18n>Examens</small>
                          </div>
                        </div>
                        <p i18n class="desc">
                          Une diversité d’examens permettant la révision de toutes les docimologies
                          pour les EDN et les ECOS.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="overview__grid__rt">
                    <div class="overview__card overview__card__hor">
                      <figure class="thumb">
                        <img
                          src="assets/assets-site/images/landing-v2/overview-thumb-two.webp"
                          alt=""
                        />
                      </figure>
                      <figcaption class="caption">
                        <h6 i18n class="ttl">Alex D</h6>
                        <p i18n class="desc">
                          Bien utilisée, cette prépa permet réellement de changer notre externat
                          <strong>156ème EDN24</strong>
                        </p>
                      </figcaption>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div appObserveVisibility (visible)="getExamsLanding()"></div>

        <section *ngIf="!exams || exams.length" class="exams__section cmn__section">
          <div class="container">
            <div class="block__ttl block__ttl__md">
              <h2 i18n class="block__ttl__hdng">
                Examens <span class="text-secondary">gratuits</span> en ce moment !
              </h2>
            </div>

            <div class="exams__slider overflow-hidden">
              <div #examsSwiper class="swiper">
                <div class="swiper-wrapper">
                  <div *ngFor="let exam of exams" class="swiper-slide">
                    <div class="exams__card">
                      <div class="top">
                        <div class="top__lt">
                          <span class="video__btn">
                            <div class="max-w-[280px] truncate">{{ exam?.title }}</div>
                          </span>

                          <div *ngIf="exam?.averageRating" class="star__rating">
                            <i class="star__icon"
                              ><img
                                src="assets/assets-site/images/landing-v2/star.svg"
                                alt=""
                                class="svg"
                            /></i>

                            <span class="ratings">{{
                              exam?.averageRating | number : '1.1-1' : 'fr'
                            }}</span>
                          </div>
                        </div>
                        <div class="top__rt">
                          <span i18n class="badge bg-rose">Gratuit</span>
                        </div>
                      </div>

                      <div class="middle">
                        <div class="ttl">
                          {{ exam?.theme }}
                        </div>

                        <ng-container *ngIf="exam">
                          <div class="badge__grp">
                            <span
                              *ngFor="
                                let specialty of exam.specialties | slice : 0 : 3;
                                let i = index
                              "
                              class="badge bg-grey"
                              >{{ specialty.name }}</span
                            >
                            <span *ngIf="exam.specialties.length > 3" class="badge bg-grey"
                              >+{{ exam.specialties.length - 3 }}</span
                            >
                          </div>
                        </ng-container>
                      </div>

                      <div class="bottom">
                        <div class="avtar__grp">
                          <span class="avtar__count px-4"
                            >{{
                              exam?.statistic.totalParticipantsWhoFinishedAtLeastOneExamContent
                            }}
                            <ng-container i18n>participants</ng-container></span
                          >
                        </div>

                        <div *ngIf="exam" class="btm__rt">
                          <span class="badge badge__lgt">
                            <ng-container *ngIf="exam.totalFolders > 0">
                              {{ exam.totalFolders }} {{ 'card.dossiers' | translate }}&nbsp;-&nbsp;
                            </ng-container>
                            <ng-container
                              *ngIf="exam.totalFolderQuestions + exam.totalIsolatedQuestions > 0"
                            >
                              {{ exam.totalFolderQuestions + exam.totalIsolatedQuestions }}
                              {{ 'training.questions' | translate }}&nbsp;-&nbsp;
                            </ng-container>
                            {{ exam.totalTimerDuration / 60 }}
                            {{ 'examens.min' | translate }}&nbsp;-&nbsp;
                            {{ exam.difficulty | examDifficulty }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="performance__section cmn__section">
          <div class="container position-relative">
            <span class="perfo__shape">
              <img src="assets/assets-site/images/landing-v2/performance-shape.svg" alt="" />
            </span>
            <div class="performance__blk">
              <div class="performance__blk__lt">
                <div class="">
                  <ng-lottie
                    appObserveVisibility
                    (visible)="playAnimAncrage()"
                    width="100%"
                    height="100%"
                    containerClass="box-set"
                    [options]="animAncrageOptions"
                    (animationCreated)="animAncrageCreated($event)"
                  ></ng-lottie>
                </div>
              </div>
              <div class="performance__blk__rt">
                <div class="block__ttl block__ttl__wt mb-0">
                  <span class="block__ttl__tagline">
                    <i class="icon"
                      ><img
                        src="assets/assets-site/images/landing-v2/performance-icon.svg"
                        alt=""
                        class="svg"
                    /></i>
                    <ng-container i18n>PERFORMANCE</ng-container>
                  </span>
                  <h2 *ngIf="!languageService.isPrepMIR()" i18n class="block__ttl__hdng">
                    Mémorise plus facilement avec l’ancrage des connaissances®
                  </h2>
                  <p i18n class="block__ttl__desc">
                    Notre logiciel d'ancrage des connaissances® utilise un algorithme développé par
                    nos ingénieurs pour optimiser ta mémoire à long terme. L'utilisation de la
                    répétition espacée permet d'assurer un apprentissage efficace, pour ne rien
                    oublier le jour J.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="cmn__section tools__section">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="block__ttl block__ttl__tools">
                  <h2 i18n class="block__ttl__hdng">Tous les outils de votre réussite</h2>
                </div>
              </div>

              <div class="tools__content__row">
                <div class="scroll__track">
                  <div class="scroll__thumb"></div>
                </div>
                <div *ngIf="languageService.coursesEnabled" class="row">
                  <div class="col-lg-5 offset-lg-1">
                    <div class="block__ttl block__ttl__dark mb-0">
                      <span
                        class="block__ttl__tagline text-primary d-flex align-items-center gap-2 mb-2"
                        ><i class="icon"
                          ><img
                            src="assets/assets-site/images/landing-v2/course-icon.svg"
                            alt=""
                            class="svg"
                        /></i>
                        <ng-container i18n>COURS</ng-container></span
                      >
                      <h2 i18n class="block__ttl__hdng">
                        Révise avec notre module de fiches unique mis à jour avec les dernières
                        recommandations
                      </h2>
                      <p i18n class="block__ttl__desc">
                        Pour la préparation d’un concours où la répétition et la mémorisation sont
                        les clés de la réussite, un module de répétition espacée basé sur les
                        derniers travaux de mémorisation pour ancrer durablement les notions les
                        plus complexes.
                      </p>
                      <div class="block__ttl__grp">
                        <a [routerLink]="['/user/login']" class="btn btn-primary btn-sm">
                          <ng-container i18n>Essayer</ng-container>
                          <i class="icon">
                            <img
                              src="assets/assets-site/images/landing-v2/arrow-circle-rt.svg"
                              alt=""
                              class="svg"
                            />
                          </i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <ng-lottie
                      appObserveVisibility
                      (visible)="playAnimCours()"
                      width="100%"
                      height="100%"
                      containerClass="box-set"
                      [options]="animCoursOptions"
                      (animationCreated)="animCoursCreated($event)"
                    ></ng-lottie>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-5 offset-lg-1">
                    <div class="block__ttl block__ttl__dark mb-0">
                      <span
                        class="block__ttl__tagline text-primary d-flex align-items-center gap-2 mb-2"
                        ><i class="icon"
                          ><img
                            src="assets/assets-site/images/landing-v2/training-icon.svg"
                            alt=""
                            class="svg"
                        /></i>
                        <ng-container i18n>TRAINING</ng-container></span
                      >
                      <h2 i18n class="block__ttl__hdng">
                        Le module d'entrainement par excellence boosté à l'ancrage des
                        connaissances ®
                      </h2>
                      <p i18n class="block__ttl__desc">
                        Pour la préparation d’un concours où la répétition et la mémorisation sont
                        les clés de la réussite, un module de répétition espacée basé sur les
                        derniers travaux de mémorisation pour ancrer durablement les notions les
                        plus complexes.
                      </p>
                      <div class="block__ttl__grp">
                        <a [routerLink]="['/user/login']" class="btn btn-primary btn-sm">
                          <ng-container i18n>Essayer</ng-container>
                          <i class="icon">
                            <img
                              src="assets/assets-site/images/landing-v2/arrow-circle-rt.svg"
                              alt=""
                              class="svg"
                            />
                          </i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <ng-lottie
                      appObserveVisibility
                      (visible)="playAnimTraining()"
                      width="100%"
                      height="100%"
                      containerClass="box-set"
                      [options]="animTrainingOptions"
                      (animationCreated)="animTrainingCreated($event)"
                    ></ng-lottie>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-5 offset-lg-1">
                    <div class="block__ttl block__ttl__dark mb-0">
                      <span
                        class="block__ttl__tagline text-primary d-flex align-items-center gap-2 mb-2"
                        ><i class="icon"
                          ><img
                            src="assets/assets-site/images/landing-v2/type-icon.svg"
                            alt=""
                            class="svg"
                        /></i>
                        {{ (examTypes$ | async)?.length }}
                        <ng-container i18n>TYPES D’EXAMENS</ng-container></span
                      >
                      <h2 i18n class="block__ttl__hdng">
                        Evalue toi parmis des milliers d'étudiants à travers
                        {{ (examTypes$ | async)?.length }} types d'examens
                      </h2>
                      <p i18n class="block__ttl__desc">
                        Des types d’examens diversifiés, axés sur les principales docimologies de la
                        réforme du deuxième cycle, avec pour but de faire varier les supports
                        d’entraînement et favoriser l’apprentissage actif dans tous les domaines.
                      </p>
                      <div class="block__ttl__grp">
                        <a [routerLink]="['/user/login']" class="btn btn-primary btn-sm">
                          <ng-container i18n>Essayer</ng-container>
                          <i class="icon">
                            <img
                              src="assets/assets-site/images/landing-v2/arrow-circle-rt.svg"
                              alt=""
                              class="svg"
                            />
                          </i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <ng-lottie
                      appObserveVisibility
                      (visible)="playAnimType()"
                      width="100%"
                      height="100%"
                      containerClass="box-set"
                      [options]="animTypeOptions"
                      (animationCreated)="animTypeCreated($event)"
                    ></ng-lottie>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-5 offset-lg-1">
                    <div class="block__ttl block__ttl__dark mb-0">
                      <span
                        class="block__ttl__tagline text-primary d-flex align-items-center gap-2 mb-2"
                        ><i class="icon"
                          ><img
                            src="assets/assets-site/images/landing-v2/play-icon.svg"
                            alt=""
                            class="svg"
                        /></i>
                        <ng-container i18n>PLAY</ng-container></span
                      >
                      <h2 i18n class="block__ttl__hdng">
                        Mémorise différement avec nos vidéos et nos podcats de cours
                      </h2>
                      <p i18n class="block__ttl__desc">
                        Un module de podcasts ludique, pour réviser en toutes circonstances et
                        stimuler sa mémoire auditive, et une vidéothèque de vidéos explicatives des
                        points de cours sélectifs vous attendent sur le site.
                      </p>
                      <div class="block__ttl__grp">
                        <a [routerLink]="['/user/login']" class="btn btn-primary btn-sm">
                          <ng-container i18n>Essayer</ng-container>
                          <i class="icon">
                            <img
                              src="assets/assets-site/images/landing-v2/arrow-circle-rt.svg"
                              alt=""
                              class="svg"
                            />
                          </i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <ng-lottie
                      appObserveVisibility
                      (visible)="playAnimPlay()"
                      width="100%"
                      height="100%"
                      containerClass="box-set"
                      [options]="animPlayOptions"
                      (animationCreated)="animPlayCreated($event)"
                    ></ng-lottie>
                  </div>
                </div>
                <div *ngIf="languageService.isEcosEnabled" class="row">
                  <div class="col-lg-5 offset-lg-1">
                    <div class="block__ttl block__ttl__dark mb-0">
                      <span
                        class="block__ttl__tagline text-primary d-flex align-items-center gap-2 mb-2"
                        ><i class="icon"
                          ><img
                            src="assets/assets-site/images/landing-v2/ecos-icon.svg"
                            alt=""
                            class="svg"
                        /></i>
                        <ng-container i18n>ECOS</ng-container></span
                      >
                      <h2 i18n class="block__ttl__hdng">
                        Un module spécial ECOS pour faire la différence
                      </h2>
                      <p i18n class="block__ttl__desc">
                        Une rubrique inédite, comportant à la fois des fiches sur les situations de
                        départ pour maximiser ses points sur les grilles de correction et une
                        plateforme interactive sous la forme d’un chat intelligent reprenant les
                        réponses et informations des patients simulés
                      </p>
                      <div class="block__ttl__grp">
                        <a [routerLink]="['/user/login']" class="btn btn-primary btn-sm">
                          <ng-container i18n>Essayer</ng-container>
                          <i class="icon">
                            <img
                              src="assets/assets-site/images/landing-v2/arrow-circle-rt.svg"
                              alt=""
                              class="svg"
                            />
                          </i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <ng-lottie
                      appObserveVisibility
                      (visible)="playAnimEcos()"
                      width="100%"
                      height="100%"
                      containerClass="box-set"
                      [options]="animEcosOptions"
                      (animationCreated)="animEcosCreated($event)"
                    ></ng-lottie>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-5 offset-lg-1">
                    <div class="block__ttl block__ttl__dark mb-0">
                      <span
                        class="block__ttl__tagline text-primary d-flex align-items-center gap-2 mb-2"
                        ><i class="icon"
                          ><img
                            src="assets/assets-site/images/landing-v2/challenge-icon.svg"
                            alt=""
                            class="svg"
                        /></i>
                        <ng-container i18n>CHALLENGE</ng-container></span
                      >
                      <h2 i18n class="block__ttl__hdng">
                        Un mode unique de gaming pour défier tes amis sur leurs connaissances
                      </h2>
                      <p i18n class="block__ttl__desc">
                        Défie tes amis avec notre mode challenge, et révisez à plusieurs de manière
                        ludique sur notre banque de questions isolées.
                      </p>
                      <div class="block__ttl__grp">
                        <a [routerLink]="['/user/login']" class="btn btn-primary btn-sm">
                          <ng-container i18n>Essayer</ng-container>
                          <i class="icon">
                            <img
                              src="assets/assets-site/images/landing-v2/arrow-circle-rt.svg"
                              alt=""
                              class="svg"
                            />
                          </i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <ng-lottie
                      appObserveVisibility
                      (visible)="playAnimChallenge()"
                      width="100%"
                      height="100%"
                      containerClass="box-set"
                      [options]="animChallengeOptions"
                      (animationCreated)="animChallengeCreated($event)"
                    ></ng-lottie>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="update__section cmn__section">
          <span class="update__shape">
            <img src="assets/assets-site/images/landing-v2/update-shape.svg" alt="" class="svg" />
          </span>
          <div class="update__section__inn">
            <div class="container">
              <div class="row align-items-center">
                <div class="col-lg-6 col-xl-7 update__section__inn__lt">
                  <div class="block__ttl block__ttl__wt block__ttl__sm">
                    <span class="block__ttl__tagline d-flex align-items-center gap-2 mb-3"
                      ><i class="icon"
                        ><img
                          src="assets/assets-site/images/landing-v2/file-icon.svg"
                          alt=""
                          class="svg"
                      /></i>
                      <ng-container i18n>Mises à jours en continu</ng-container></span
                    >
                    <h2 i18n class="block__ttl__hdng">Mise à jour et nouveaux contenus</h2>
                    <p i18n class="block__ttl__desc">
                      Nos équipes de rédacteurs ont pour objectif de maintenir une base de donnée à
                      jour sur les dernières
                      <strong>recommandations exigibles aux EDN</strong>.
                    </p>
                    <p *ngIf="languageService.isEcni()" i18n class="block__ttl__desc">
                      Nous veillons attentivement être à jour des dernières recommandations, HAS,
                      sociétés savantes, et dernières éditions de collèges qui sont renouvelées
                      chaque année.
                    </p>
                  </div>

                  <div class="update__counts">
                    <div class="update__counts__col">
                      <!-- nnkitodo [v2later] dynamique -->
                      <div class="top">
                        <i class="icon">
                          <img
                            src="assets/assets-site/images/landing-v2/graduation-icon.svg"
                            alt=""
                            class="svg"
                          />
                        </i>
                        <ng-container i18n>467 539</ng-container>
                      </div>
                      <p i18n class="desc">
                        C'est le nombre de feedbacks étudiants que nous avons collecté pour mettre a
                        jour nos questions et nos cours
                      </p>
                    </div>
                    <div class="update__counts__col">
                      <div class="top">
                        <i class="icon">
                          <img
                            src="assets/assets-site/images/landing-v2/file-checkmark.svg"
                            alt=""
                            class="svg"
                          />
                        </i>
                        <ng-container i18n>6 875</ng-container>
                      </div>
                      <p i18n class="desc">
                        C'est le nombre de mise à jour que nous avons réalisé sur nos fiches et
                        questions ces 3 derniers mois
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-5 update__section__inn__rt">
                  <div class="update__thumbnail">
                    <div class="thumb__blk">
                      <i class="ring__img"
                        ><img
                          src="assets/assets-site/images/landing-v2/ring.svg"
                          class="svg"
                          alt=""
                      /></i>
                      <div class="thumb__collage">
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-1.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-2.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-3.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-4.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-5.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-6.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-7.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-8.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-9.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-10.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-11.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-12.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-13.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-14.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-15.png"
                            alt=""
                          />
                        </i>
                        <i class="collage__item">
                          <img
                            src="assets/assets-site/images/landing-v2/video-thumb-16.png"
                            alt=""
                          />
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div appObserveVisibility (visible)="getFeaturedTestimoniesLanding()"></div>
        <section class="cmn__section testimonial__section">
          <div class="container">
            <div #landingTestimoniesSwiper class="swiper testimonial__swiper overflow-hidden">
              <ng-container *ngIf="landingTestimonies">
                <div class="swiper-wrapper">
                  <div *ngFor="let testimony of landingTestimonies" class="swiper-slide">
                    <div class="testi__card">
                      <div class="row">
                        <div class="col-lg-4">
                          <div class="testi__lt">
                            <i class="icon">
                              <img
                                src="assets/assets-site/images/landing-v2/quote-icon.svg"
                                alt=""
                                class="svg"
                              />
                            </i>
                            <blockquote class="quote__text">
                              {{ testimony.quote }}
                            </blockquote>
                            <div class="quote__dtl">
                              <i class="pfl__icon">
                                <img [src]="testimony.picture" alt="" />
                              </i>
                              <span class="name"
                                >{{ testimony.firstName }}
                                <small>{{ testimony.ecnRank }}</small></span
                              >
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-8">
                          <div class="testi__rt">
                            <div class="testi__cont" [innerHTML]="testimony.content"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="landingTestimonies.length > 1" class="swiper__nav__grp z-1">
                  <div class="swiper-button-prev swiper__nav__btn">
                    <img
                      src="assets/assets-site/images/landing-v2/left-arrow.svg"
                      alt=""
                      class="svg"
                    />
                  </div>
                  <div class="swiper-button-next swiper__nav__btn">
                    <img
                      src="assets/assets-site/images/landing-v2/right-arrow.svg"
                      alt=""
                      class="svg"
                    />
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </section>

        <section class="cmn__section cta__section">
          <div class="container">
            <div class="cta__blk">
              <div class="cta__lt">
                <div i18n class="title">
                  Téléchargez notre application pour profiter pleinement de EDN
                </div>
              </div>
              <div class="cta__rt">
                <div class="cta__btn__col">
                  <a [href]="languageService.appStoreUrl" target="_blank" class="cta__btn">
                    <img src="assets/assets-site/images/landing-v2/appstore.svg" class="svg" />
                  </a>

                  <span class="rating"> App Store  <small i18n>4,8 / 5</small> </span>
                </div>
                <div class="cta__btn__col">
                  <a [href]="languageService.googlePlayUrl" target="_blank" class="cta__btn">
                    <img src="assets/assets-site/images/landing-v2/googleplay.svg" class="svg" />
                  </a>

                  <span class="rating"> Play Store  <small i18n>4,7 / 5</small> </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="cmn__section instagram__section">
          <div class="container">
            <div class="row">
              <div class="col-lg-3">
                <div class="block__ttl block__ttl__md mb-0">
                  <h2 i18n class="block__ttl__hdng">edn.fr sur <br />instagram</h2>
                  <p class="block__ttl__desc">
                    <a
                      i18n
                      [href]="languageService.instagramUrl"
                      target="_blank"
                      class="text-decoration-none"
                      >&#64;edn__fr</a
                    >
                  </p>
                </div>
              </div>
              <div class="col-lg-9">
                <div class="insta__grid">
                  <div class="post__col">
                    <img src="assets/assets-site/images/landing-v2/instagram-1.jpg" alt="" />
                  </div>
                  <div class="post__col">
                    <img src="assets/assets-site/images/landing-v2/instagram-2.jpg" alt="" />
                  </div>
                  <div class="post__col">
                    <img src="assets/assets-site/images/landing-v2/instagram-3.jpg" alt="" />
                  </div>
                  <div class="post__col">
                    <img src="assets/assets-site/images/landing-v2/instagram-4.jpg" alt="" />
                  </div>
                  <div class="post__col">
                    <img src="assets/assets-site/images/landing-v2/instagram-5.jpg" alt="" />
                  </div>
                  <div class="post__col">
                    <img src="assets/assets-site/images/landing-v2/instagram-6.jpg" alt="" />
                  </div>
                  <div class="post__col">
                    <img src="assets/assets-site/images/landing-v2/instagram-7.jpg" alt="" />
                  </div>
                  <div class="post__col">
                    <img src="assets/assets-site/images/landing-v2/instagram-8.jpg" alt="" />
                  </div>
                  <div class="post__col">
                    <img src="assets/assets-site/images/landing-v2/instagram-9.jpg" alt="" />
                  </div>
                  <div class="post__col">
                    <img src="assets/assets-site/images/landing-v2/instagram-10.jpg" alt="" />
                  </div>
                  <div class="post__col">
                    <img src="assets/assets-site/images/landing-v2/instagram-11.jpg" alt="" />
                  </div>
                  <div class="post__col">
                    <img src="assets/assets-site/images/landing-v2/instagram-12.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <footer id="footer" class="footer">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-3">
              <div class="ftr__logo">
                <img src="assets/assets-site/images/landing-v2/logo.svg" alt="" class="svg" />
              </div>
            </div>
            <div class="col-lg-6">
              <ul class="ftr__links">
                <li><a i18n [routerLink]="['/legal/cgu']">CGU</a></li>
                <li><a i18n [routerLink]="['/legal/cgv']">CGV</a></li>
                <li><a i18n [routerLink]="['/legal/mentions']">Mentions légales</a></li>
                <li>
                  <a i18n [routerLink]="['/legal/confidentiality']">Politique de confidentialité</a>
                </li>
              </ul>
            </div>
            <div class="col-lg-3">
              <div class="scl__icons">
                <a [href]="languageService.facebookUrl" target="_blank" class="scl__btn">
                  <img src="assets/assets-site/images/landing-v2/fb.svg" alt="" class="svg" />
                </a>
                <a [href]="languageService.instagramUrl" target="_blank" class="scl__btn">
                  <img src="assets/assets-site/images/landing-v2/insta.svg" alt="" class="svg" />
                </a>
                <a
                  *ngIf="languageService.tiktokUrl"
                  [href]="languageService.tiktokUrl"
                  target="_blank"
                  class="scl__btn"
                >
                  <img
                    src="assets/assets-site/images/landing-v2/socialicons.svg"
                    alt=""
                    class="svg"
                  />
                </a>
                <a
                  *ngIf="languageService.telegramUrl"
                  [href]="languageService.telegramUrl"
                  target="_blank"
                  class="scl__btn"
                >
                  <img src="assets/assets-site/images/landing-v2/telegram.svg" alt="" class="svg" />
                </a>
                <a
                  *ngIf="languageService.discordUrl"
                  [href]="languageService.discordUrl"
                  target="_blank"
                  class="scl__btn"
                >
                  <img
                    src="assets/assets-site/images/landing-v2/discord.svg"
                    alt=""
                    class="svg w-[30px]"
                  />
                </a>
              </div>
            </div>

            <div class="col-12">
              <div class="ftr__btm">
                <p class="copyright">
                  &copy; {{ (nowService.now$ | async).getFullYear() }}
                  {{ 'landing.ecnifr' | translate : { siteName: languageService.siteName } }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</div>
